module.exports = __webpack_public_path__ + "img/avatar-10.51c4843c.jpg";